import { API_BASE_URL } from "../lib/api/env";

/**
 * The API host for the legacy request layer (`utils/axios.js`).
 *
 * Previously this was a hardcoded `dev-api-sapphire.hexkode.com` used to
 * fetch `/apps/init`, which in turn supplied the real base URL, api key and
 * socket URL at runtime. The Sayagie backend has no `/apps/init` (404), so
 * configuration is static now and comes from `lib/api/env.js` — one source
 * of truth for both the legacy layer and `lib/api/client.js`.
 *
 * Override with REACT_APP_API_BASE_URL to point at another environment.
 */
export const INIT_URL = API_BASE_URL;

export const MAP_BOX_TOKEN =
  "pk.eyJ1IjoidXNtYW5ha21hbGNzIiwiYSI6ImNsM21uamM3dTA2ZnIzY2w4emx6bnM5cTUifQ.UtYrxGIyhwFdCn7z5-CUBA";
/**
 * Google Maps / Places / Geocoding.
 *
 * The literal below is the Firebase browser key, on a Cloud project with
 * billing disabled: Geocoding and Places both answer REQUEST_DENIED ("You
 * must enable Billing on the Google Cloud Project"). Maps, the signup address
 * autocomplete and reverse geocoding are all dead while it is in use.
 *
 * Set REACT_APP_GOOGLE_MAPS_KEY to a billing-enabled key to fix them. It is
 * read here rather than at each call site so the three loaders — Home, HexMap
 * and the signup address field — stay on ONE configuration: the Maps JS
 * loader is a singleton and throws if called again with different options.
 *
 * A browser key is public by definition, so whichever key is used must carry
 * an HTTP-referrer restriction for the web origins in the Cloud console.
 */
export const GOOGLE_MAP_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_KEY || "AIzaSyCh3JL1XaakN6ClsZiIzQD3Rg765fevJmQ";
